'use strict';

import React from 'react';
import {h, Fragment} from 'preact';
import BreadcrumbsMobile from './Breadcrumbs/Mobile';
import BreadcrumbsDesktop from './Breadcrumbs/Desktop';

export default function Breadcrumbs(props) {
    if (typeof window === 'undefined') {
        // Do not render on server side
        return '';
    }

    return global.config.isMobile ? <BreadcrumbsMobile {...props} /> : <BreadcrumbsDesktop {...props} />;
}
